module.exports = {"321012100":"仙女镇","321012101":"小纪镇","321012103":"武坚镇","321012106":"樊川镇","321012108":"真武镇","321012109":"宜陵镇","321012110":"丁沟镇","321012112":"郭村镇","321012114":"邵伯镇","321012116":"丁伙镇","321012118":"大桥镇","321012119":"吴桥镇","321012120":"浦头镇","321012400":"立新农场","321012401":"滨江新城管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321012.json
// module id = 916
// module chunks = 0